import { render, staticRenderFns } from "./set_map.vue?vue&type=template&id=2ba3b18c&scoped=true&"
import script from "./set_map.vue?vue&type=script&lang=js&"
export * from "./set_map.vue?vue&type=script&lang=js&"
import style0 from "./set_map.vue?vue&type=style&index=0&id=2ba3b18c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3b18c",
  null
  
)

export default component.exports